<template>
    <div class="pa-5 ma-3 white rounded-lg">
        <v-row>
            <v-col cols="8">
                <div class="subheading grey--text mb-9">Ambassador List</div>
            </v-col>
            <v-col cols="4" class="text-right">
                <v-btn depressed color="grey darken-4" class="white--text" to="/ambassadors/new">
                    <v-icon left>mdi-plus</v-icon>
                    New
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="6" offset="6" class="pt-0">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Filter" single-line hide-details></v-text-field>
            </v-col>
        </v-row>
        
        <v-data-table :headers="headers" :items="items" :footer-props="paginationOptions" :search="search"
            item-key="id" :options="pagination" :loading="loading" @click:row="toAmbassadorDetails" @pagination="onPagination">
            <template v-slot:item.active="{ item }">
                <v-chip x-small label :color="item.active ? 'success' : 'error'">{{ item.active ? 'Yes' : 'No' }}</v-chip>
            </template>
            <template v-slot:item.dateCreated="{ item }">
                {{ formatDate( item.dateCreated, 'MMM DD, YYYY' ) }}
            </template>
        </v-data-table>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import { _st } from '@/softech';

export default {
    data: () => ({
        headers     : [
            // { text: 'ID', value: 'id', sortable: true },
            { text: 'Name', value: 'name', sortable: true },
            { text: 'School', value: 'school', sortable: true },
            { text: 'Active', value: 'active', sortable: true },
            { text: 'Created On', value: 'dateCreated', sortable: true },
        ],
        pagination: {
            sortBy: ['orderDate']
        },
        paginationOptions: { itemsPerPageOptions: [ 25, 50, -1 ] },
        loading: false,
        search: '',
    }),
    computed: {
        ...mapGetters({
            items       : 'ambassadors/ambassadors',
            hasMore     : 'ambassadors/hasMore',
            needRefresh : 'ambassadors/needRefresh'
        })
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions({
            loadAmbassadors: 'ambassadors/loadAmbassadors'
        }),
        async init() {
            try {
                if( !this.needRefresh )
                    return;

                this.loading = true;
                await this.loadAmbassadors();
            }
            finally {
                this.loading = false;
            }
        },
        formatDate(d, f = 'YYYY-MM-DD') {
            if( _st.isNUE( d ) )
                return '';

            return moment(d).format(f);
        },
        onPagination(v) {
            if( v.pageCount != v.page || this.search != '' ) {
                return;
            }

            this.loadMore();
        },
        async loadMore() {
            try {
                if( !this.hasMore )
                    return;
                
                this.loading = true;
                await this.loadAmbassadors();
                this.loading = false;
            }
            catch(error) {
                this.loading = false;
            }
        },
        toAmbassadorDetails(item) {
            this.$router.push(`/ambassadors/${item.id}`);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>